import { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import TextField from './TextField';

const TextFieldTaxId = props => {
  const { maxChars = 9, ...other } = props;
  const [show, setShow] = useState(false);

  return (
    <TextField
      type={show ? 'text' : 'password'}
      endIcon={
        <IconButton
          size="small"
          aria-label="toggle tax id visibility"
          onClick={() => setShow(!show)}
          onMouseDown={e => e.preventDefault()}
        >
          {!show ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      }
      inputProps={{
        pattern: '[0-9]*',
        inputMode: 'numeric',
        maxLength: maxChars,
        minLength: 9,
      }}
      {...other}
    />
  );
};

export default TextFieldTaxId;
